module.exports = __webpack_public_path__ + "img/normal_amazake.93a1f4e8.jpg";